export function isHarmonyOS(userAgent = '') {
  return /HarmonyOS|OpenHarmony|ArkWeb/i.test(userAgent)
}
